import knowledgeApi from '@/lib/knowledge-api'

export interface AppConnection {
  id: number
  provider: 'hubspot' | 'servicenow' | 'salesforce'
  label: string
  status: 'connected' | 'disconnected' | 'error'
  config: Record<string, unknown>
  metadata: Record<string, unknown>
  connected_at: string | null
  has_credentials: boolean
}

export interface CreateConnectionPayload {
  provider: 'hubspot' | 'servicenow' | 'salesforce'
  label?: string
  credentials: Record<string, string>
  config?: Record<string, unknown>
}

export interface TestResult {
  ok: boolean
  message: string
}

const api = knowledgeApi

export const connectionsApi = {
  list: () => api.get<{ connections: AppConnection[] }>('/connections/api/'),

  create: (data: CreateConnectionPayload) =>
    api.post('/connections/api/create/', data),

  disconnect: (id: number) =>
    api.post(`/connections/api/${id}/delete/`),

  test: (id: number) =>
    api.post<TestResult>(`/connections/api/${id}/test/`),

  getHubSpotAuthorizeUrl: () => '/connections/api/hubspot/authorize/',
}
